import { generateReducer, } from "../generators/generator.reducer";
import { GENERATOR_PARAMS } from "./scheduledExport.constants";
var reducer = generateReducer(GENERATOR_PARAMS);
// eslint-disable-next-line import/no-default-export
export default reducer;
